import script from "./ResourcePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcePage.vue?vue&type=script&setup=true&lang=ts"

import "./ResourcePage.vue?vue&type=style&index=0&id=d113342e&lang=css"

const __exports__ = script;

export default __exports__